module.exports = __webpack_public_path__ + "img/avatar2.0c29617f.png";